module.exports = __webpack_public_path__ + "img/cycle-3_a_button.30853c75.png";